const descriptions = [
    { value: 'AAA Employee', label: 'AAA Employee' },
    { value: 'Accommodation', label: 'Accommodation' },
    { value: 'Association', label: 'Association' },
    { value: 'Attraction', label: 'Attraction' },
    { value: 'Aviation', label: 'Aviation' },
    { value: 'Corporate Travel', label: 'Corporate Travel' },
    { value: 'Cruise', label: 'Cruise' },
    { value: 'Destination Management Company', label: 'Destination Management Company' },
    { value: 'Financial Services', label: 'Financial Services' },
    { value: 'Government Agency', label: 'Government Agency' },
    { value: 'Ground Transportation', label: 'Ground Transportation' },
    { value: 'Insurance', label: 'Insurance' },
    { value: 'Media', label: 'Media' },
    { value: 'Non-Profit', label: 'Non-Profit' },
    { value: 'Other', label: 'OTHER' },
    { value: 'Retail', label: 'Retail' },
    { value: 'Technology', label: 'Technology' },
    { value: 'Tourism Board', label: 'Tourism Board' },
    { value: 'Tour Operator', label: 'Tour Operator' },
    { value: 'Tours & Activities', label: 'Tours & Activities' },
];

export default descriptions;
